import { usePatientRisks } from '@ctw/shared/api/risk-service';
import { withErrorBoundary } from '@ctw/shared/components/errors/error-boundary';
import { useMainContentHeader } from '@ctw/shared/components/layout/main-content-with-dockable-drawer';
import { EmptyPatientTable } from '@ctw/shared/content/empty-patients-table';
import { ResourceTable } from '@ctw/shared/content/resource/resource-table';
import { ResourceTableActions } from '@ctw/shared/content/resource/resource-table-actions';
import { useFilteredSortedData } from '@ctw/shared/hooks/use-filtered-sorted-data';
import { patientRiskGapsColumns } from './helpers/columns';
import { RiskGapFilters } from './helpers/filters';
import { defaultRiskSort, riskSortOptions } from './helpers/sorts';

export const PatientRiskGaps = withErrorBoundary({
  boundaryName: 'PatientRiskGaps',
  Component: () => {
    const risksQuery = usePatientRisks();

    const { data, filters, setFilters, setSort, defaultSort } = useFilteredSortedData({
      cacheKey: 'patient-risk-gaps',
      defaultSort: defaultRiskSort,
      records: risksQuery.data,
    });

    const hasZeroFilteredRecords = !risksQuery.isLoading && data.length === 0;

    useMainContentHeader(
      'PatientRiskGapsContentHeader',
      () => (
        <ResourceTableActions
          filterOptions={{
            filters: RiskGapFilters,
            selected: filters,
            onChange: setFilters,
          }}
          sortOptions={{
            defaultSort,
            options: riskSortOptions,
            onChange: setSort,
          }}
        />
      ),
      [filters, defaultSort],
    );

    return (
      <ResourceTable
        title="Patient Risk Gaps"
        titleVisuallyHidden={true}
        showTableHead={true}
        isLoading={risksQuery.isLoading}
        stackedBreakpoint="xs"
        columns={patientRiskGapsColumns}
        data={data}
        emptyMessage={
          <EmptyPatientTable
            hasZeroFilteredRecords={hasZeroFilteredRecords}
            resourceName="risk opportunities"
          />
        }
      />
    );
  },
});
